export const quantityParsed = (value) => parseInt(value.replace('.', '').replace(',', '.'), 10);
